module.exports = __webpack_public_path__ + "media/services/smart-sales-4f353f4a.svg";